import { render, staticRenderFns } from "./lazyblock_school_panel.vue?vue&type=template&id=deaaa40a&scoped=true"
import script from "./lazyblock_school_panel.vue?vue&type=script&lang=js"
export * from "./lazyblock_school_panel.vue?vue&type=script&lang=js"
import style0 from "./lazyblock_school_panel.vue?vue&type=style&index=0&id=deaaa40a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deaaa40a",
  null
  
)

export default component.exports